<template>
    <div>
        <div class="content-header text-center">
            <h2>Email Append Lookup</h2>
            <p class="lead">PLEASE NOTE: You have {{this.userSubscription.email}} email append credits left. <a @click="$emit('customChange', {shell: 'SelectEmailAppend', dataset: ''})" class="btn btn-outline-primary">Click Here to purchase more.</a></p>
            <p class="lead">The email append tool pulls email addresses in increments of 10,000, per lookup request. Files are limited to 25,000 total rows. The application will attempt to match append email lists with select datasets or uploaded files, based on filename and selected range.</p>
        </div>
        <div class="container-fluid min-content-height">
            <div class="row">
                <div v-if="this.userSubscription.email > 1" class="col">
                    <div class="tabbed-padding" id="emailappendcollapse">
                        <ul class="nav nav nav-tabs">
                        <li class="nav-item me-1" id="headingOne">
                            <a class="nav-link" data-bs-toggle="collapse" data-bs-target="#emailselect" aria-expanded="true" aria-controls="emailselect">Select Existing Email List</a>
                        </li>
                        <li class="nav-item me-1" id="headingTwo">
                            <a class="nav-link" data-bs-toggle="collapse" data-bs-target="#datasetselect" aria-expanded="false" aria-controls="datasetselect">Select Existing Dataset</a>
                        </li>
                        <li class="nav-item me-1" id="headingThree">
                            <a class="nav-link" data-bs-toggle="collapse" data-bs-target="#prospectselect" aria-expanded="false" aria-controls="prospectselect">Select Existing Prospect List</a>
                        </li>
                        <li class="nav-item me-1" id="headingFour">
                            <a class="nav-link" data-bs-toggle="collapse" data-bs-target="#fileselect" aria-expanded="false" aria-controls="fileselect">Upload New File</a>
                        </li>
                        </ul>
                        <div class="tab-content py-5 px-2">
                            <div class="container-fluid">
                                <div class="collapse show" id="emailselect"  aria-labelledby="headingOne" data-bs-parent="#emailappendcollapse">
                                    <form id="emailappendfile" method="post" @submit.prevent="processEmailListFile">
                                        <label class="small mb-1">Select Email List</label>
                                        <select class="form-select" v-model="selecteddb">
                                            <option v-for="option in emailpre" :value="option" :key="option">{{option}}</option>
                                        </select>
                                        <button type="submit" class="btn btn-lg btn-block btn-primary" v-on:click="retieveEmailList()">Generate Appended Email List</button>
                                    </form>
                                </div>
                                <div class="collapse" id="datasetselect"  aria-labelledby="headingTwo" data-bs-parent="#emailappendcollapse">
                                    <form id="emailappenddataset" method="post" @submit.prevent="processEmailListFile">
                                        <label class="small mb-1">Select Dataset</label>
                                        <select class="form-select" v-model="selecteddb">
                                            <option v-for="option in datasets" :value="option" :key="option">{{option}}</option>
                                        </select>
                                        <button type="submit" class="btn btn-lg btn-block btn-primary" v-on:click="processDatasetList()">Generate Appended Email List</button>
                                    </form>
                                </div>
                                <div class="collapse" id="prospectselect"  aria-labelledby="headingThree" data-bs-parent="#emailappendcollapse">
                                    <form id="emailappendprospect" method="post" @submit.prevent="processEmailListFile">
                                        <label class="small mb-1">Select Prospect</label>
                                        <select class="form-select" v-model="selecteddb">
                                            <option v-for="option in prospects" :value="option" :key="option">{{option}}</option>
                                        </select>
                                        <button type="submit" class="btn btn-lg btn-block btn-primary" v-on:click="processDatasetList()">Generate Appended Email List</button>
                                    </form>
                                </div>
                                <div class="collapse" id="fileselect" aria-labelledby="headingFour" data-bs-parent="#emailappendcollapse">
                                    <form id="emailappend" method="post" @submit.prevent="processEmailList">
                                        <div class="form-group">
                                            <label class="small mb-1">Upload CSV Formatted File</label>
                                            <div class="form-text">To ensure maximum number of successful results, be sure to follow our guidelines in formatting your CSV formatted list.</div>
                                            <input type="file" name="file" id="fileUpload" ref="file" v-on:change="handleFileUpload($event)" />
                                        </div>
                                        <button type="submit" class="btn btn-lg btn-block btn-primary" v-on:click="processNewEmailList()">Generate Appended Email List</button>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>    
                </div>
                <div v-else>
                    <p>You currently have {{this.userSubscription.email}} credits remaining, you need to purchase more credits to continue.</p>
                    <button class="btn btn-primary" @click="$emit('customChange', {shell: 'SelectEmailAppend', dataset: ''})">Purchase Email Credits</button>
                </div>           
            </div>
            <div class="row" v-if="this.emaillists.length >= 1">
                <div class="col">
                    <h3 class="text-center">Completed Email Appended Files</h3>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <div class="col-lg-6 offset-lg-3">
                    <div class="btn-group-vertical col-12"  v-for='data in emaillists' v-bind:key="data">
                    <div class="btn-group mb-2" role="group">
                        <a class="btn col-8 btn-lg btn-primary" v-bind:href="'/download_appended_result?appended='+data+'.csv'"  v-bind:download="data + '.csv'" target="_blank"><span class="sidebar-text">{{data}}</span></a>
                        <a class="btn col-2 btn-lg btn-danger" @click="$emit('deleteFile', {filename: String(data+'.csv'), directory: 'emailappends'})"><i class="fas fa-trash-alt"></i></a>
                        <a class="btn col-2 btn-lg btn-info d-none" @click="$emit('openModal', {view: 'RenameProspect', dt: String(data)})"><i class="fas fa-edit"></i></a>
                    </div>
                    </div>
                </div>
                </div>
            </div>
            <div class="row" v-if="this.legacylists.length >= 1 && this.emaillists.length >= 1">
                <div class="col">
                    <hr>
                </div>
            </div>
            <div class="row" v-if="this.legacylists.length >= 1">
                <div class="col">
                    <h3 class="text-center">Legacy Email Appended Files</h3>
                    <p class="lead text-center">These lists were generated with our previous email append service.</p>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <div class="col-lg-6 offset-lg-3">
                    <div class="btn-group-vertical col-12"  v-for='data in legacylists' v-bind:key="data">
                    <div class="btn-group mb-2" role="group">
                        <a class="btn col-8 btn-lg btn-primary" v-bind:href="'/user_dataset?dataset='+data+'.csv&amp;format=raw&amp;objid=null'"  v-bind:download="data + '.csv'" target="_blank"><span class="sidebar-text">{{data}}</span></a>
                        <a class="btn col-2 btn-lg btn-danger" @click="$emit('deleteFile', {filename: String(data+'.csv'), directory: 'datasets'})"><i class="fas fa-trash-alt"></i></a>
                        <a class="btn col-2 btn-lg btn-info d-none" @click="$emit('openModal', {view: 'RenameProspect', dt: String(data)})"><i class="fas fa-edit"></i></a>
                    </div>
                    </div>
                </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import axios from 'axios';
export default {
    name: 'EmailAppend',
    props: {
        userData: [],
        userSubscription: [],
        activeEmailAppend: [],
        emailAppendFile: '',
        userStatus: '',
        thisRemaining: '',
        isAdmin: {
            type: Boolean,
            default() {
                return false
            }
        },
        passedData: {
            type: String,
            default() {
                return 'Dataset'
            }
        },
        passedModalData: '',
    }, 
    data() {
        return {
            datasets: [],
            prospects: [],
            reports: [],
            emailpre: [],
            emaillists: [],
            legacylists: [],
            file: null,
            selecteddb: ''
        }
    },
    methods: {
        processNewEmailList() {
            let formData = new FormData();
            formData.append('file', this.file);
            axios({
                method : 'POST',
                url : '/save_new_email_list',
                data: formData
            }).then(
                (response) => {
                    var d = response.data;
                    var selectedIndexes = d[0];
                    var dropdownValues = d[1];
                    var retainFileName = d[3];
                    var fileTypeInfo = d[4];
                    var fileErrorInfo = d[5];
                    var ranges = fileTypeInfo.length;
                    // console.log('ranges data '+ranges);
                    this.$emit('setEmailMashup', {si: selectedIndexes, dv: dropdownValues, rf: retainFileName, ft: fileTypeInfo, er: fileErrorInfo})
                }).catch(error => {
                    this.errorMessage = error.message;
                    console.error("There was an error!", error);
            });   
        },
        processDatasetList() {
            let formData = new FormData();
            formData.append('dataset', this.selecteddb);
            console.log('selected dataset '+this.selecteddb);
            axios({
                method : 'POST',
                url : '/save_dataset_email_list',
                data: formData
            }).then(
                (response) => {
                    var d = response.data;
                    var selectedIndexes = d[0];
                    var dropdownValues = d[1];
                    var retainFileName = d[3];
                    var fileTypeInfo = d[4];
                    var fileErrorInfo = d[5];
                    var ranges = fileTypeInfo.length;
                    // console.log('ranges data '+ranges);
                    this.$emit('setEmailMashup', {si: selectedIndexes, dv: dropdownValues, rf: retainFileName, ft: fileTypeInfo, er: fileErrorInfo})
            }).catch(error => {
                    this.errorMessage = error.message;
                    console.error("There was an error!", error);
            }); 
        },
        retieveEmailList() {
            let formData = new FormData();
            formData.append('emaillist', this.selecteddb);
            console.log('selected emailist '+this.selecteddb);
            axios({
                method : 'POST',
                url : '/retrieve_email_list',
                data: formData
            }).then(
                (response) => {
                    var d = response.data;
                    var selectedIndexes = d[0];
                    var dropdownValues = d[1];
                    var retainFileName = d[3];
                    var fileTypeInfo = d[4];
                    var fileErrorInfo = d[5];
                    var ranges = fileTypeInfo.length;
                    // console.log('ranges data '+ranges);
                    this.$emit('setEmailMashup', {si: selectedIndexes, dv: dropdownValues, rf: retainFileName, ft: fileTypeInfo, er: fileErrorInfo})
            }).catch(error => {
                    this.errorMessage = error.message;
                    console.error("There was an error!", error);
            }); 
        },
        handleFileUpload(event){
          this.file = this.$refs.file.files[0];
      },
        customDeleteDataset(filename) {
            axios.get('/remove_dataset', { params: {dataset: filename} })
            .then(
                    (response) => {
                this.$emit('messageAlert', {alert: 'Deleting selected Appended Email list.', classel: 'info'});
                this.returnUpdatedList();
                this.$emit('customChange', {shell: 'EmailAppend', dataset: ''});
            }).catch(error => {
                this.errorMessage = error.message;
                this.$emit('messageAlert', {alert: 'There was an error!', classel: 'error'});
                console.error("There was an error!", error);
            });
        },
        returnUpdatedList() {
            axios({
                method : 'POST',
                url : '/list_datasets',
                data:'',
            }).then(response => this.datasets = processDatasetList(response.data))
                .catch(error => {
                this.errorMessage = error.message;
                console.error("There was an error!", error);
            });
        },
        customDeleteAppend(filename) {
            axios.get('/remove_appended', { params: {dataset: filename} })
            .then(
                    (response) => {
                this.$emit('messageAlert', {alert: 'Deleting selected Dataset.', classel: 'info'});
                this.returnUpdatedList();
            }).catch(error => {
                this.errorMessage = error.message;
                this.$emit('messageAlert', {alert: 'There was an error!', classel: 'error'});
                console.error("There was an error!", error);
            });
        },
        deleteFile(thefile) {
            console.log('attempting to delete (should be a path) '+thefile);
            var deletePath = '/s/'+this.userData.uid+'/emailappends/'+thefile+'.csv';
            console.log('attempting to delete (should be a path) '+deletePath);
            axios.get('/delete_a_file', { params: {delete: deletePath} })
            .then(
                (response) => {
                    console.log('the response '+JSON.stringify(response));
                    // this.userSubscription = JSON.stringify(response.data);
                    
                })
                .catch(error => {
                    this.errorMessage = error.message;
                    console.error("There was an error!", error);
                });
            }
    },
    mounted() {
         axios({
            method : 'POST',
            url : '/get_emailappend_list',
            data:'',
        }).then(response => this.emailpre = processEmailList(response.data))
            .catch(error => {
                this.errorMessage = error.message;
                console.error("There was an error!", error);
        });
        axios({
            method : 'POST',
            url : '/list_datasets',
            data:'',
        }).then(response => {
            this.datasets = processDatasetList(response.data);
            this.prospects = processProspects(response.data);
            return response;
            })
            .catch(error => {
                this.errorMessage = error.message;
                console.error("There was an error!", error);
        });
        axios({
            method : 'POST',
            url : '/list_emaillists_bulk',
            data:'',
        }).then(response => {
            this.emaillists = processEmailList(response.data);
            console.log('test dataset email response: '+this.emaillists);
        })
            .catch(error => {
                this.errorMessage = error.message;
                console.error("There was an error!", error);
        });
        axios({
            method : 'POST',
            url : '/list_reports',
            data:'',
        }).then(response => {
            this.reports = processDatasetList(response.data);
            return response;
        })
            .catch(error => {
                this.errorMessage = error.message;
                console.error("There was an error!", error);
        }); 
        axios({
                method : 'POST',
                url : '/list_emaillists',
                data:'',
            }).then(response => {
                this.legacylists = processEmailList(response.data);
                console.log('legacy email append list (from datasets): '+JSON.stringify(this.legacylists));
            }).catch(error => {
                this.errorMessage = error.message;
                console.error("There was an error!", error);
            });
    }
}
function processDatasetList(data) {
      var iH = [];
      var i;
      var b = data;
      for (i = 0; i < b.length; i++) {
        if (b[i].includes('scored-') || b[i].includes('prospect'))
          continue;
            iH.push(b[i]); 
      };
      return iH;
}
function processProspects(data) {
      var iH = [];
      var i;
      var b = data;
      for (i = 0; i < b.length; i++) {
        if (b[i].includes('scored-') || !b[i].includes('prospect'))
          continue;
            iH.push(b[i]); 
      };
      return iH;
}
function processEmailList(data) {
      var iH = [];
      var i;
      var b = data;
      for (i = 0; i < b.length; i++) {
        iH.push(b[i]);
      };
      return iH;
}
</script>